import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Breadcrumb, Card, Col, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Image } from "antd";
import PsContext from "../../context";
import {
  DB_POSTFIX,
  IMAGES_512,
  NO_IMAGE_LOGO_WIDE,
  getFileLiveUrl,
  makeUrl,
} from "../../utils";
import LoaderIcon from "../../utils/LoaderIcon";
import { ServiceUrl } from "../../utils/serviceUrl";

const DepartmentList = (props) => {
  const context = useContext(PsContext);
  const [loader, setLoader] = useState(false);
  const [courseType, setCourseType] = useState("");

  const [dataList, setDataList] = useState([]);
  const [dataView, setDataView] = useState([]);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = () => {
    setLoader(true);
    axios.post(ServiceUrl.DEPARTMENTS + "?sadb=" + DB_POSTFIX).then((res) => {
      if (res["data"].status == "1") {
        setDataList(res["data"].data);
        setDataView(res["data"].data);
      }
      setLoader(false);
    });
  };

  const listCourses = (item) => {
    return (
      <Col md={4} className="mb-4">
        <Link
          to={`/department/${item.id}/${makeUrl(item.department)}`}
          className="department-link text-decoration-none"
        >
          <Card className="department-card overflow-hidden border-0 text-white h-100">
            <Card.Img
              src={getFileLiveUrl(item.department_logo)}
              className="department-card-img"
            />
            <Card.ImgOverlay className="d-flex align-items-end p-0">
              <div className="w-100 bg-dark bg-opacity-50 text-center py-2">
                <h5 className="m-0 department-name">{item.department}</h5>
              </div>
            </Card.ImgOverlay>
          </Card>
        </Link>
      </Col>
    );
  };

  return (
    <>
      <section
        className="page-hero d-flex align-items-center"
        style={{
          backgroundImage:
            "url('https://portal.aei.edu.in//files_list/aei/drsacoe/fm/website/bredcrumbs/Campus_View2lwdf.jpg')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "220px",
          position: "relative",
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
          }}
        ></div>

        <div className="container position-relative text-white">
          <Breadcrumb>
            <Breadcrumb.Item href="/" className="text-light">
              Home
            </Breadcrumb.Item>
          </Breadcrumb>
          <h2 className="fw-bold mb-0">Departments</h2>
        </div>
      </section>

      <section>
        <div className="container pg-inn ps_min_height">
          {loader && <LoaderIcon />}
          <div className="my-4"></div>
          <Row>{dataView.map((item) => listCourses(item))}</Row>
        </div>
      </section>
    </>
  );
};

export default DepartmentList;
